var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"trigger-booking-engine",class:_vm.is_open && 'trigger-booking-engine--active',on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('vb-icon',{attrs:{"name":_vm.is_open ? 'cross_circle' : 'lens',"color":"--info","size":23}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }